import * as React from 'react';
import { useEffect, useState } from 'react';
import styles from '../styles/wizards/AddSubstageWizard.scss';
import AddSubstageIcon from '../assets/images/add-stage-60x60.svg';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import { createSubstage } from '../redux/actions/table/substages';
import AddSubstageForm from '../forms/add_substage_wizard/AddSubstageForm';
import { readProjectGeneral } from '../redux/actions/projects';
import { listProjectSubstages, readStage } from '../redux/actions/table/stages';

const AddSubstageWizard = ({ onClose, match, table }) => {
  const [projectLanguages, setProjectLanguages] = useState(null);
  const selectedStageId =
    typeof table?.wizard_active === 'object'
      ? table.wizard_active.stage_id
      : undefined;

  useEffect(() => {
    readProjectGeneral(match.params.project).then(({ response }) => {
      const project_languages = {};

      project_languages[response.data.main_language] = 1;
      (response.data.additional_languages || []).forEach((language_id) => {
        project_languages[language_id] = 0;
      });

      setProjectLanguages(project_languages);
    });
  }, [match.params.project]);

  const _handleSubmit = (formData) => {
    return validateForm(
      createSubstage(formData).then(({ response }) => {
        setTableParams('substages', {
          wizard_active: false,
        });

        readStage(formData.stage_id);
        listProjectSubstages(match.params.project);

        onClose();

        setNotification(__('wizard.add-substage.notification.success'));
      })
    );
  };
  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('wizard.add-substage.title.create-new')}</span>
          <span>{__('wizard.add-substage.subtitle.create-new')}</span>
        </div>
        <div className={styles.right}>
          <AddSubstageIcon />
        </div>
      </div>
      <div className={styles.body}>
        {projectLanguages && (
          <AddSubstageForm
            projectLanguages={projectLanguages}
            initialStageId={selectedStageId}
            onSubmit={_handleSubmit}
            initialValues={{
              // status: '0',
              // duration: '60',
              status: 'started',
              stage_id: selectedStageId,
            }}
          />
        )}
      </div>
    </>
  );
};

export default withRouter(
  mapStateToProps((state) => ({
    table: state.table['substages'],
  }))(AddSubstageWizard)
);
